export default "__VITE_ASSET__BmnqCPZQ__"